/**
 * B2B org Stripe subscription.status values that keep paid entitlements in the API.
 * Keep in sync with server `STRIPE_SUBSCRIPTION_STATUS_ACTIVE_SET` (stripe.constants.js).
 */
export function isOrgB2bStripeSubscriptionStatusPaid(status: string | null | undefined): boolean {
  if (status == null || typeof status !== 'string') return false
  const s = status.trim()
  if (!s) return false
  return s === 'active' || s === 'trialing' || s === 'past_due'
}
